import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-circular-progress',
  templateUrl: './circular-progress.component.html',
  styleUrls: ['./circular-progress.component.scss']
})
export class CircularProgressComponent implements OnChanges {
  @Input() value = 0;
  @Input() total = 100;
  @Input() showPercentage = true;
  @Input() size = 160;
  @Input() fillColor = 'var(--primary-color)';
  @Input() baseColor = 'var(--gray-1)';
  @Input() thickness = 24;
  @Input() customClass = '';
  @Input() customStyle: Record<string, any> = {};

  percentage = 0;
  radius = 0;
  circumference = 0;
  strokeDashoffset = 0;
  centerFontSize = 20;

  ngOnChanges(): void {
    this.updateValues();
  }

  private updateValues() {
    const totalSafe = this.total > 0 ? this.total : 0;
    const raw = totalSafe > 0 ? (this.value / totalSafe) * 100 : 0;
    this.percentage = Math.max(0, Math.min(100, Math.round(raw)));

    const effectiveThickness = Math.max(1, Math.min(this.thickness, this.size / 2));
    this.radius = (this.size - effectiveThickness) / 2;
    this.circumference = 2 * Math.PI * this.radius;
    this.strokeDashoffset = this.circumference * (1 - this.percentage / 100);

    this.centerFontSize = Math.max(10, Math.round(this.size * 0.2));
  }

  getStyle() {
    return Object.assign(
      {
        width: this.size + 'px',
        height: this.size + 'px'
      },
      this.customStyle || {}
    );
  }
}
